// Funciones auxiliares
export const GAME_ID = "mainGame";

export function randomId() {
  return "p_" + Date.now() + "_" + Math.floor(Math.random() * 100000);
}

export function formatMoney(n = 0) {
  return "$" + n.toFixed(2);
}
